import { render } from "./AddInsuranceMoreDetailsPage.vue?vue&type=template&id=b41573c4&scoped=true"
import script from "./AddInsuranceMoreDetailsPage.vue?vue&type=script&lang=js"
export * from "./AddInsuranceMoreDetailsPage.vue?vue&type=script&lang=js"

import "./AddInsuranceMoreDetailsPage.vue?vue&type=style&index=0&id=b41573c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b41573c4"]])

export default __exports__